import styled from 'styled-components';
import { th } from 'style/theme';
import { sizes } from 'style';

export const StyledStepContainer = styled.div`
  flex: 1;
  position: relative;
  height: 100%;
  border-radius: 16px;
  background-color: ${th('colors.white')};

  @media ${sizes.desktop} {
    border-radius: 24px;
  }
`;

export const Controls = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px;
  border-top-right-radius: 16px;
  border-top-left-radius: 16px;
  background-color: ${th('colors.pickledBluewood45')};
  border-bottom: 1px solid ${th('colors.pickledBluewood35')};

  @media ${sizes.desktop} {
    border-top-right-radius: 24px;
    border-top-left-radius: 24px;
  }
`;

export const BackButton = styled.button`
  display: flex;
  align-items: center;
  padding: 0;
  border: none;
  font-weight: 500;
  font-size: 16px;
  font-family: 'Helvetica Now';
  color: ${th('colors.pickledBluewood')};
  background-color: transparent;
  cursor: pointer;
`;

export const BackIcon = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  margin-right: 8px;
  border-radius: 50%;
  background-color: ${th('colors.pickledBluewood35')};
`;

export const StepDisplay = styled.div`
  flex-shrink: 0;
  padding: 4px 8px;
  border-radius: 20px;
  font-weight: 500;
  color: ${th('colors.fountainBlue-2')};
  background-color: ${th('colors.fountainBlue+4')};

  @media ${sizes.desktop} {
    color: ${th('colors.pickledBluewood1')};
    background-color: transparent;
  }
`;

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  padding: 16px;

  @media ${sizes.tabletPortrait} {
    padding: 32px;
  }
`;
